<template>
  <div class="setAttachment">
    <a-drawer
      title="设置附件题"
      :width="680"
      @close="onClose"
      :visible="setAttachShow"
      :bodyStyle="{ paddingBottom: '80px' }"
    >
      <a-form-model
        ref="attachForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="题目标题：" prop="questionTitle">
          <a-input v-model="form.questionTitle" type="textarea" rows="5" placeholder="请输入题目标题，不超过500字" />
        </a-form-model-item>
        <a-form-model-item label="附件格式：" prop="format">
          <a-radio-group v-model="form.format">
            <a-radio value="1">
              文档
            </a-radio>
            <a-radio value="2">
              音视频
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item>
          <p style="color: #999;margin-bottom: 0;height: 26px;line-height: 26px;">文档：支持word、excel、ppt、pdf、caj、jpg、bmp、rar、zip格式</p>
          <p style="color: #999;margin-bottom: 0;height: 26px;line-height: 26px;">音视频：支持MP4、mkv、wmv、3gp、avi、mp3、wav、wma格式</p>
        </a-form-model-item>
      </a-form-model>
      <div
        :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 10000,
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="onClose">
            取消
        </a-button>
        <a-button @click="onSubmit" type="primary">确定</a-button>
      </div>
    </a-drawer>
    <div v-show="loading" class="example">
      <a-spin />
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      setAttachShow: false,
      isEditAttachMsg: false,
      attAssignmentId: '',
      labelCol: { span: 3 },
      wrapperCol: { span: 24 },
      form: {
        questionTitle: '',
        format: ''
      },
      rules: {
        questionTitle: [
          { required: true, message: '请输入题目标题', trigger: 'blur' },
          { max: 500, message: '最多输入500个字符', trigger: 'blur' }
        ],
        format: [
          { required: true, message: '请选择附件格式', trigger: 'change' }
        ]
      },
      loading: false
    }
  },
  methods: {
    showModal(){
      this.setAttachShow = true;
    },
    editAttachMsg(item){
      this.setAttachShow = true;
      this.isEditAttachMsg = true;
      this.form.questionTitle = item.assignmentName;
      this.form.format = item.assignmentTypeFormat.toString();
      this.attAssignmentId = item.attAssignmentId;
    },
    onClose(){
      this.setAttachShow = false;
      this.form.questionTitle = '';
      this.form.format = '';
    },
    onSubmit() {
      this.$refs.attachForm.validate(valid => {
        if (valid) {
          this.sbmAttachment();
          this.loading = true;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    sbmAttachment(){
      let data = {
        'assignmentName': this.form.questionTitle,
        'assignmentType': '1',
        'assignmentTypeFormat': this.form.format
      };
      if (this.isEditAttachMsg){
        data.attAssignmentId = this.attAssignmentId;
        data.updatedBy = this.appUtils.getUserId();
      } else {
        data.attinfoId = this.appUtils.getCourseInfo().attinfoId;
        data.createdBy = this.appUtils.getUserId();
      }
      let url = this.apis.coursework.saveOrUpdateAssignment;
      this.http.post(url, data)
      .then((res)=>{
        if (res.status == 0){
          this.$message.success('保存成功');
          this.isEditAttachMsg = false;
          this.loading = false;
          this.onClose();
          this.$emit('getOneAttInfo');
        }
      }).catch((err)=> {
        this.$message.error(err.message);
      });
    }
  }
}
</script>

<style lang="less" scoped>
.example {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 30px 50px;
    margin: 0;
    z-index: 1001;
    & > * {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>